<template>
  <v-card color="transparent" flat>
    <v-card-title>
      <v-row>
        <v-col>Task lists</v-col>
        <v-col align="right">
          <form-modal
            btnText="New task list"
            modalTitle="Create task list"
            color="secondary"
            depressed
          >
            <template #form="{ cancel }">
              <task-list-create-edit-form
                @cancel="cancel"
                :projectId="project.id"
              />
            </template>
          </form-modal>
        </v-col>
      </v-row>
    </v-card-title>

    <v-card-text class="pa-0">
      <v-fade-transition mode="out-in">
        <v-row v-if="loading" key="loading">
          <v-col cols="6" v-for="index in 4" :key="index">
            <v-card outlined>
              <v-skeleton-loader
                type="table-heading, list-item-three-line"
              ></v-skeleton-loader>
            </v-card>
          </v-col>
        </v-row>

        <v-row v-else-if="project.task_lists.length" key="success">
          <v-col
            cols="6"
            v-for="taskList in project.task_lists"
            :key="taskList.id"
          >
            <project-task-list :taskList="taskList" />
          </v-col>
        </v-row>

        <v-row v-else>
          <v-col cols="12">
            <v-card width="100%" outlined key="empty">
              <v-card-title class="subtitle-1">No tasks found.</v-card-title>
            </v-card>
          </v-col>
        </v-row>
      </v-fade-transition>
    </v-card-text>
  </v-card>
</template>

<script>
import ProjectTaskList from './ProjectTaskList'
import FormModal from '@/components/common/FormModal'
import TaskListCreateEditForm from '../common/TaskListCreateEditForm'

export default {
  name: 'ProjectTaskLists',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    project: {
      type: Object,
      required: true
    }
  },
  components: {
    ProjectTaskList,
    FormModal,
    TaskListCreateEditForm
  }
}
</script>
